import { Routes, Route } from "react-router-dom";
import ListProjectReport from "../Components/Project Report/listProjectReport";
import AddProjectReport from "../Components/Project Report/addProjectReport";
import ViewProjectReport from "../Components/Project Report/viewProjectReport";
import EditProjectReport from "../Components/Project Report/editProjectReport";

const ProjectReportRoutes = () => {
  return (
    <Routes>
      <Route path="/project_report" element={<ListProjectReport />} />
      <Route path="/project_report/add" element={<AddProjectReport />} />
      <Route path="/project_report/view/:id" element={<ViewProjectReport />} />
      <Route path="/project_report/edit/:id" element={<EditProjectReport />} />
    </Routes>
  );
};

export default ProjectReportRoutes;